import { useState, useCallback, useRef } from "react";
import "component/inputs/multipleSelect.scss";
import "pages/detailPicker/detailPicker.scss";
import classNames from "classnames";
import { ReactComponent as Arrow } from "assets/flechaAbajo.svg";

const Select = ({
  id,
  input,
  label,
  options = [],
  placeholder,
  onChange,
  disabled,
  loading,
  smallDropdown = false,
  testId,
}) => {
  const [open, setOpen] = useState(false);
  const divRef = useRef();

  const globalClose = useCallback(
    (event) => {
      if (divRef.current && !divRef.current.contains(event.target)) {
        setOpen(false);
        window.removeEventListener("mousedown", globalClose);
      }
    },
    [setOpen]
  );

  const handleClick = (e) => {
    e.stopPropagation();
    window.addEventListener("mousedown", globalClose);
    if (!disabled) {
      setOpen(!open);
    }
  };

  const handleChange = (name, option) => {
    onChange(name, option);
    setOpen(false);
  };

  return (
    <div className="multiple-selectbox" ref={divRef}>
      <div onClick={handleClick} className="multiple-contenido-select" id={id}>
        <label
          id={id + "-label"}
          data-testId={`${testId}-label`}
          className={`label-Admin-Pickers ${disabled ? " disabled" : ""} `}
        >
          {label}
        </label>
        <input
          id={id + "-input"}
          name={input.name}
          placeholder={placeholder}
          value={
            input.value.label && input.value.label !== ""
              ? input.value.label
              : input.value.name && input.value.name !== ""
              ? input.value.name
              : ""
          }
          disabled
          className={`Admin-Pickers-input-select ${
            disabled ? " disabled" : ""
          }`}
          type="text"
          data-testId={testId}
        />
        {!disabled && (
          <Arrow
            className={classNames("multiple-select-icon", {
              "multiple-select-icon-disabled": disabled,
              "multiple-select-icon-open": open,
            })}
          />
        )}
      </div>
      {open && (
        <div
          className="filter-admin-options"
          id={id + "-dropdown"}
          data-testId={`${testId}-dropdown`}
        >
          {loading ? (
            <div className="spinner-container">
              <div className="spinner" />
            </div>
          ) : (
            <div
              className={classNames("filter-admin-scroll", {
                "filter-admin-scroll-small": smallDropdown,
              })}
            >
              {options.map((option, key) => (
                <div
                  className="filter-admin-content-option"
                  key={key}
                  id={id + "-option-" + key}
                  onMouseDown={(e) => {
                    handleChange(input.name, option);
                  }}
                >
                  <label className="filter-admin-option-paragraph">
                    {option.label}
                  </label>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Select;
